import { DragDropContext } from "react-beautiful-dnd"
import React, { Component } from "react"
import dayjs from "dayjs"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../Redux/Actions"
import RoadmapperDroppableContainer from "../RoadmapperDroppableContainer/RoadmapperDroppableContainer"
import "./RoadmapperDraggableContainer.css"
import RoadmapperConstraintEvent from "../RoadmapperConstraintEvent/RoadmapperConstraintEvent"
import CommitButtonWithClickState from "../CommitButtonWithClickState/CommitButtonWithClickState"
import RoadmapperCalenderContainer from "../RoadmapperCalenderContainer/RoadmapperCalenderContainer"
import SkeletonWrapper from "../SkeletonWrapper/SkeletonWrapper"

/* props
momentFormat: ["h:mm",""]
momentJoiner: " - "
timeConstraints: {
  start: dayjs(""),
  end: dayjs("")
} 
durationUnit: "minutes||whatever"
*/

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class RoadmapperDraggableContainer extends Component {
    constructor(props) {
      super(props)

      this.state = {
        awaiting: false,
        eventIds: null,
        editing: false,
        isBeingDragged: false,
        isDragDisabled: false,
        eventIdBeingEdited: null,
        skeletonLoader: false,
        skeletonWidth: 0,
        skeletonWidthRatio: 0,
        editedEvent: {
          title: "",
          value: null,
          duration: 15
        },
        loading: true,
        timeEvents: null
      }

      this.renderMoment = this.renderMoment.bind(this)
      this.onDragEnd = this.onDragEnd.bind(this)
      this.onDragStart = this.onDragStart.bind(this)
      this.updateState = this.updateState.bind(this)
      this.storeUpdatedTimeEvent = this.storeUpdatedTimeEvent.bind(this)
      this.updateEditEvent = this.updateEditEvent.bind(this)
      this.deleteTimeEvent = this.deleteTimeEvent.bind(this)
      this.addTimeEvent = this.addTimeEvent.bind(this)
      this.updateConstraint = this.updateConstraint.bind(this)
      this.addDateEvent = this.addDateEvent.bind(this)
      this.updateEditCalenderEvent = this.updateEditCalenderEvent.bind(this)
      this.deleteCalenderEvent = this.deleteCalenderEvent.bind(this)
      this.dateSortingFunction = this.dateSortingFunction.bind(this)
    }

    resizeSkeletonWidth = () => {
      const container = document.getElementById("skeletonContainer")
      this.setState({
        skeletonWidth: container.clientWidth,
        skeletonWidthRatio: container.clientWidth / 300
      })
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.resizeSkeletonWidth)
    }

    componentDidMount(prevState) {
      this.resizeSkeletonWidth()
      window.addEventListener("resize", this.resizeSkeletonWidth)
      
      // Initialize with data if available
      let eventIds = []
      if (this.props.eventOrder) {
        if (Array.isArray(this.props.eventOrder)) {
          eventIds = this.props.eventOrder.map((eventId) => eventId)
        } else if (typeof this.props.eventOrder === 'object' && this.props.eventOrder.sequence) {
          const sequence = this.props.eventOrder.sequence
          if (Array.isArray(sequence)) {
            eventIds = sequence
          } else if (typeof sequence === 'string') {
            eventIds = sequence.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
          }
        }
      }
      
      const timeEvents = this.props.userTimeEvents && Array.isArray(this.props.userTimeEvents)
        ? this.props.userTimeEvents.map((event) => {
            // Normalize moment_data (handle both moment_data and momentData)
            const normalizedEvent = {
              ...event,
              moment_data: event.moment_data || event.momentData || null
            }
            // Remove momentData if it exists to avoid confusion
            if (normalizedEvent.momentData) {
              delete normalizedEvent.momentData
            }
            return normalizedEvent
          })
        : []
      
      // Always set loading to false after mount - show empty state if no data
      // Don't wait for props.loading to be false
      // Use a small timeout to ensure parent component has finished initializing
      setTimeout(() => {
        this.setState({
          eventIds,
          loading: false,
          timeEvents,
          skeletonLoader: false
        })
      }, 100)
    }

    componentDidUpdate(prevProps) {
      // Update when data changes
      if (prevProps.eventOrder !== this.props.eventOrder || 
          prevProps.userTimeEvents !== this.props.userTimeEvents || 
          prevProps.loading !== this.props.loading ||
          prevProps.values !== this.props.values) {
        let eventIds = this.state.eventIds || []
        
        if (this.props.eventOrder) {
          if (Array.isArray(this.props.eventOrder)) {
            eventIds = this.props.eventOrder.map((eventId) => eventId)
          } else if (typeof this.props.eventOrder === 'object' && this.props.eventOrder.sequence !== undefined) {
            const sequence = this.props.eventOrder.sequence
            if (Array.isArray(sequence)) {
              eventIds = sequence
            } else if (typeof sequence === 'string') {
              eventIds = sequence.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
            }
          }
        }
        
        // Map timeEvents and ensure values are correctly set
        const timeEvents = this.props.userTimeEvents && Array.isArray(this.props.userTimeEvents)
          ? this.props.userTimeEvents.map((event) => {
              // Normalize moment_data (handle both moment_data and momentData)
              const normalizedEvent = {
                ...event,
                moment_data: event.moment_data || event.momentData || null
              }
              
              // Remove momentData if it exists to avoid confusion
              if (normalizedEvent.momentData) {
                delete normalizedEvent.momentData
              }
              
              // Ensure value is correctly set based on value_id and available values
              if (normalizedEvent.value_id && this.props.values && Array.isArray(this.props.values)) {
                const matchingValue = this.props.values.find((val) => val && val.id === normalizedEvent.value_id)
                if (matchingValue && (!normalizedEvent.value || normalizedEvent.value === "Non-Value")) {
                  normalizedEvent.value = matchingValue.name || matchingValue.value || "Non-Value"
                }
              }
              return normalizedEvent
            })
          : (this.state.timeEvents || [])
        
        // Always set loading to false when parent says loading is done, or if we have any data
        // Don't wait for data - show empty state if needed
        const shouldStopLoading = !this.props.loading || eventIds.length > 0 || timeEvents.length > 0 || !this.props.loading
        
        this.setState({
          eventIds,
          loading: false, // Always stop loading in componentDidUpdate
          timeEvents,
          skeletonLoader: false // Also stop skeleton loader
        })
      }
    }

    renderCalenderMoment = (momentData) => {
      if (!momentData) return "TBD"
      
      // Try parsing with common date formats
      // HTML date inputs use YYYY-MM-DD format
      // Some legacy data might use YYYY:MM:DD format
      const parsedDate = dayjs(momentData, ["YYYY-MM-DD", "YYYY:MM:DD", "YYYY/MM/DD"], true)
      
      // If parsing failed, try auto-detection
      if (!parsedDate.isValid()) {
        const autoParsed = dayjs(momentData)
        if (autoParsed.isValid()) {
          return autoParsed.format("MMM Do")
        }
        return "TBD"
      }
      
      return parsedDate.format("MMM Do")
    }

    renderMoment = (momentData) => {
      return momentData
        .map((singleMoment, index) => {
          let currentMoment = singleMoment.format(
            this.props.momentFormat[index] ||
              this.props.momentFormat[0] ||
              this.props.momentFormat
          )
          if (index !== momentData.length - 1) {
            currentMoment = currentMoment.replace(/pm|am|PM|AM/gi, "")
          } else {
            currentMoment = ` ${currentMoment}`
          }
          return currentMoment
        })
        .join(this.props.momentJoiner);
    }

    updateState = (inObject) => {
      let { editedEvent } = this.state
      let newTimeEvents = this.state.timeEvents.map((event) => event)
      
      // Save when editing finishes (eventIdBeingEdited changes from a value to null)
      // Also save if the eventIdBeingEdited changes to a different event
      const editingFinished = inObject.eventIdBeingEdited !== this.state.eventIdBeingEdited &&
        this.state.eventIdBeingEdited !== null &&
        this.state.editedEvent &&
        this.state.editedEvent.id // Always save if we have an event ID, even if only date changed
      
      if (editingFinished) {
        // Ensure we have the latest editedEvent data
        const eventToSave = { ...this.state.editedEvent }
        
        // Store the original date format for display (YYYY-MM-DD)
        const originalDateValue = eventToSave.moment_data
        
        // Keep date in YYYY-MM-DD format (database format with hyphens)
        // No conversion needed - HTML input already returns YYYY-MM-DD which is the correct database format
        let databaseDateValue = originalDateValue
        if (this.props.calender && eventToSave.moment_data) {
          const dateValue = eventToSave.moment_data
          // If it's in YYYY:MM:DD format (old format), convert to YYYY-MM-DD
          if (typeof dateValue === 'string' && dateValue.match(/^\d{4}:\d{2}:\d{2}$/)) {
            databaseDateValue = dateValue.replace(/:/g, '-')
            eventToSave.moment_data = databaseDateValue
          }
          // If already in YYYY-MM-DD format, keep it as-is
          else if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
            databaseDateValue = dateValue
            eventToSave.moment_data = databaseDateValue
          }
        }
        
        // Ensure we're using moment_data (not momentData)
        if (eventToSave.momentData && !eventToSave.moment_data) {
          eventToSave.moment_data = eventToSave.momentData
          delete eventToSave.momentData
        }
        
        console.log('[RoadmapperDraggableContainer] Saving event:', {
          eventId: eventToSave.id,
          title: eventToSave.title,
          originalDate: originalDateValue,
          databaseDate: eventToSave.moment_data,
          isCalender: this.props.calender
        })
        
        // Update local state IMMEDIATELY with the selected date so UI shows the change
        // Keep the original format (YYYY-MM-DD) for display, save will convert to database format
        newTimeEvents = this.state.timeEvents.map((event) => {
          if (event.id === this.state.eventIdBeingEdited) {
            // Update with the edited event data, preserving the original date format for display
            // The date will be converted to database format when saving
            const updatedEvent = {
              ...this.state.editedEvent,
              moment_data: originalDateValue || this.state.editedEvent.moment_data || null
            }
            // Remove momentData if it exists
            if (updatedEvent.momentData) {
              delete updatedEvent.momentData
            }
            
            console.log('[RoadmapperDraggableContainer] Updating local state with event:', {
              eventId: updatedEvent.id,
              title: updatedEvent.title,
              moment_data: updatedEvent.moment_data,
              hasMomentData: !!updatedEvent.momentData
            })
            
            return updatedEvent
          }
          return event
        })
        
        // Save the event (async, will update state again with response)
        this.storeUpdatedTimeEvent(eventToSave).catch((error) => {
          console.error('[RoadmapperDraggableContainer] Error saving event:', error)
        })
        
        editedEvent = {
          title: "",
          value: null,
          duration: 15
        }
      }
      this.setState({ ...inObject, timeEvents: newTimeEvents, editedEvent })
    }

    onDragEnd = async (result) => {
      const { destination, source } = result
      if (
        !destination ||
        (destination.droppableId === source.droppableId &&
          destination.index === source.index)
      ) {
        return
      }

      const newOrderedEventIds = [...this.state.eventIds]
      newOrderedEventIds.splice(source.index, 1)
      newOrderedEventIds.splice(
        destination.index,
        0,
        this.state.eventIds[source.index]
      )

      this.setState({
        eventIds: [...newOrderedEventIds],
        trackedTime: dayjs(this.props.timeConstraints.start),
        isBeingDragged: false
      })

      await this.changeEventOrder(newOrderedEventIds)
      await this.storeUpdatedTimeEvent(this.state.timeEvents[0])
    }

    onDragStart = (result) => {
      this.setState({ isBeingDragged: true })
    }

    dateSortingFunction = (a, b) => {
      if (a.moment_data) {
        if (b.moment_data) {
          return dayjs(b.moment_data).isBefore(a.moment_data) ? 1 : -1
        }
        return -1
      }
      if (b.moment_data) {
        return 1
      }
      return 0
    }

    storeUpdatedTimeEvent = async (eventData) => {
      if (this.props.calender) {
        try {
          console.log('[RoadmapperDraggableContainer] storeUpdatedTimeEvent - saving date event:', eventData)
          const response = await this.props.storeUpdatedDateEvent(eventData, this.state.eventIds)
          console.log('[RoadmapperDraggableContainer] storeUpdatedTimeEvent - save response:', response)
          
          // Update local state with saved event data from response
          // Normalize the response data to ensure moment_data is set correctly
          const updatedTimeEvents = this.state.timeEvents.map((event) => {
            if (event.id === eventData.id) {
              // Use the response data if available, normalize moment_data
              const savedEvent = response?.data || eventData
              const normalizedEvent = {
                ...savedEvent,
                moment_data: savedEvent.moment_data || savedEvent.momentData || null
              }
              // Remove momentData if it exists
              if (normalizedEvent.momentData) {
                delete normalizedEvent.momentData
              }
              // Convert database format (YYYY:MM:DD) back to display format (YYYY-MM-DD) if needed
              if (normalizedEvent.moment_data && typeof normalizedEvent.moment_data === 'string') {
                const parsed = dayjs(normalizedEvent.moment_data, ["YYYY:MM:DD", "YYYY-MM-DD", "YYYY/MM/DD"], true)
                if (parsed.isValid()) {
                  // Keep it in the format that was saved (database format YYYY:MM:DD)
                  // renderCalenderMoment can handle both formats
                  normalizedEvent.moment_data = normalizedEvent.moment_data
                }
              }
              return normalizedEvent
            }
            return event
          })
          
          const sortedEvents = updatedTimeEvents.sort((a, b) =>
          this.dateSortingFunction(a, b)
        )
          this.setState({ 
            timeEvents: sortedEvents,
            eventIds: sortedEvents.map((event) => event.id) 
          })
        } catch (error) {
          console.error('[RoadmapperDraggableContainer] Error saving date event:', error)
          throw error
        }
      } else {
        await this.props.storeUpdatedTimeEvent(eventData)
      }
    }

    deleteTimeEvent = async () => {
      if (this.state.awaiting === false) {
        const newEventOrder = this.state.eventIds.filter(
          (id) => id !== this.state.editedEvent.id
        )
        const newTimeEvents = this.state.timeEvents.filter(
          (event) => event.id !== this.state.editedEvent.id
        )
        const { editedEvent } = this.state
        this.setState({
          awaiting: true,
          timeEvents: newTimeEvents,
          editedEvent: { title: "", duration: 15, value: null },
          eventIds: newEventOrder
        })
        await this.changeEventOrder(newEventOrder)
        await this.props.deleteTimeEvent(editedEvent)
        this.setState({
          awaiting: false
        })
      }
    }

    deleteCalenderEvent = async () => {
      if (this.state.awaiting === false) {
        const newEventOrder = this.state.eventIds.filter(
          (id) => id !== this.state.editedEvent.id
        )
        const newTimeEvents = this.state.timeEvents.filter(
          (event) => event.id !== this.state.editedEvent.id
        )
        this.setState({
          awaiting: true
        })
        await this.changeEventOrder(newEventOrder)
        await this.props.deleteDateEvent(this.state.editedEvent)
        this.setState({
          timeEvents: newTimeEvents,
          editedEvent: { title: "", moment_data: 0 },
          eventIds: newEventOrder,
          awaiting: false
        })
      }
    }

    changeEventOrder = async (updatedEventOrder) => {
      await this.props.updateEventOrder(updatedEventOrder)
    }

    updateConstraint = async (newTime, AMorPM, calender) => {
      if (calender) {
        debugger
        await this.props.updateSingleLineInputById({
          newValue: newTime,
          id:
            AMorPM === "am"
              ? this.props.timeConstraints.startId
              : this.props.timeConstraints.endId
        })
      } else {
        await this.props.updateSingleLineInputById({
          newValue: newTime,
          id:
            AMorPM === "am"
              ? this.props.timeConstraints.startId
              : this.props.timeConstraints.endId
        })
      }
      await this.props.fetchPartData()
    }

    updateEditEvent = (eventData) => {
      // Convert value name to value_id
      let valueId = null
      if (eventData.value && eventData.value !== "Non-Value" && this.props.values && Array.isArray(this.props.values)) {
        const matchingValue = this.props.values.find((val) => val && (val.name === eventData.value || val.value === eventData.value))
        if (matchingValue) {
          valueId = matchingValue.id
        }
      }
      
      // If eventData already has value_id, use it (might be set from API)
      if (eventData.value_id !== undefined && eventData.value_id !== null) {
        valueId = eventData.value_id
      }
      
      this.setState({
        editedEvent: {
          ...eventData,
          value_id: valueId
        }
      })
    }

    updateEditCalenderEvent = (eventData) => {
      this.setState({
        editedEvent: {
          ...eventData
        }
      })
    }

    addTimeEvent = async (eventData) => {
      if (this.state.awaiting === false) {
        let allEvents =
          this.state.timeEvents &&
          this.state.timeEvents.map((event) => {
            return event.id === this.state.eventIdBeingEdited
              ? this.state.editedEvent
              : event
          })
        
        // Get default value_id - use first value if available, otherwise null
        const defaultValueId = this.props.values && Array.isArray(this.props.values) && this.props.values.length > 0
          ? this.props.values[0].id
          : null
        
        if (allEvents)
          allEvents.push({
            title: "",
            value_id: defaultValueId,
            duration: 15,
            id: 0
          })
        if (!allEvents)
          allEvents = [
            {
              title: "",
              value_id: defaultValueId,
              duration: 15,
              id: 0
            }
          ]
        let editedEvent
        if (this.state.editedEvent.title) {
          editedEvent = this.state.editedEvent
        }
        const tempOrder =
          (this.state.eventIds &&
            this.state.eventIds.map((eventId) => eventId)) ||
          []
        tempOrder.push(0)
        this.setState({
          awaiting: true,
          eventIdBeingEdited: null,
          skeletonLoader: true,
          eventIds: tempOrder,
          loading: false,
          timeEvents: allEvents.map((event) => event)
        })
        await this.props.createTimeEventAndUpdateOrder(
          allEvents,
          editedEvent,
          tempOrder
        )
        await this.props.fetchPartData().then(() =>
          this.setState({
            awaiting: false,
            skeletonLoader: false,
            eventIds:
              this.props.eventOrder &&
              this.props.eventOrder.map((eventId) => eventId),
            loading: false,
            timeEvents: this.props.userTimeEvents.map((event) => event),
            eventIdBeingEdited:
              this.props.eventOrder &&
              this.props.eventOrder[this.props.eventOrder.length - 1]
          })
        )
        // TODO: turn into transitionalScroll, not jump
        window.scrollTo(0, document.body.scrollHeight)
      }
    }

    addDateEvent = async (eventData) => {
      if (this.state.awaiting === false) {
        let allEvents =
          this.state.timeEvents &&
          this.state.timeEvents.map((event) => {
            return event.id === this.state.eventIdBeingEdited
              ? this.state.editedEvent
              : event
          })
        if (allEvents)
          allEvents.push({
            title: "",
            moment_data: "",
            id: 0
          })
        if (!allEvents) allEvents = [{ title: "", moment_data: "", id: 0 }]
        let editedEvent
        if (this.state.editedEvent.title) {
          editedEvent = this.state.editedEvent
        }
        const tempOrder =
          (this.state.eventIds &&
            this.state.eventIds.map((eventId) => eventId)) ||
          []
        tempOrder.push(0)
        this.setState({
          eventIds: tempOrder,
          eventIdBeingEdited: null,
          skeletonLoader: true,
          awaiting: true,
          timeEvents: allEvents.map((event) => event)
        })
        await this.props.createDateEventAndUpdateOrder(
          allEvents,
          editedEvent,
          tempOrder
        )
        await this.props.fetchPartData().then(() =>
          this.setState({
            awaiting: false,
            skeletonLoader: false,
            eventIds:
              this.props.eventOrder &&
              this.props.eventOrder.map((eventId) => eventId),
            loading: false,
            timeEvents: this.props.userTimeEvents.map((event) => event),
            eventIdBeingEdited:
              this.props.eventOrder &&
              this.props.eventOrder[this.props.eventOrder.length - 1]
          })
        )
        // TODO: turn into transitionalScroll, not jump
        window.scrollTo(0, document.body.scrollHeight)
      }
    }

    render() {
      return (
        <div id="skeletonContainer" style={styles.dragContainer}>
          {!this.state.loading ? (
            <>
              <RoadmapperConstraintEvent
                time={
                  this.props.calender
                    ? this.renderMoment([this.props.timeConstraints.start])
                    : this.props.timeConstraints.start
                }
                title={this.props.calender ? "Finish PYP" : "Wake Up"}
                AMorPM="am"
                updateConstraint={this.updateConstraint}
                calender={this.props.calender}
              />
              <DragDropContext
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStart}
              >
                {this.props.calender ? (
                  <RoadmapperCalenderContainer
                    skeletonLoader={this.state.skeletonLoader}
                    constraintStart={this.props.timeConstraints.start}
                    constraintEnd={this.props.timeConstraints.end} // for condition rendering when over
                    timeEvents={this.state.timeEvents}
                    updateParentState={this.updateState}
                    renderMoment={this.renderCalenderMoment}
                    durationUnit={this.props.durationUnit}
                    updateEditEvent={this.updateEditCalenderEvent}
                    eventIds={this.state.eventIds}
                    eventIdBeingEdited={this.state.eventIdBeingEdited}
                    deleteTimeEvent={this.deleteCalenderEvent}
                    values={this.props.values}
                  />
                ) : (
                  <RoadmapperDroppableContainer
                    skeletonLoader={this.state.skeletonLoader}
                    constraintStart={this.props.timeConstraints.start}
                    constraintEnd={this.props.timeConstraints.end} // for condition rendering when over
                    timeEvents={this.state.timeEvents}
                    updateParentState={this.updateState}
                    renderMoment={this.renderMoment}
                    durationUnit={this.props.durationUnit}
                    updateEditEvent={this.updateEditEvent}
                    eventIds={this.state.eventIds}
                    eventIdBeingEdited={this.state.eventIdBeingEdited}
                    deleteTimeEvent={this.deleteTimeEvent}
                    values={this.props.values}
                  />
                )}
              </DragDropContext>
              <RoadmapperConstraintEvent
                time={
                  this.props.calender
                    ? this.renderMoment([this.props.timeConstraints.end])
                    : this.props.timeConstraints.end
                }
                title={
                  this.props.calender
                    ? "The beginning of my next chapter"
                    : "Go To Bed"
                }
                AMorPM="pm"
                updateConstraint={this.updateConstraint}
                calender={this.props.calender}
              />
              <CommitButtonWithClickState
                type="red"
                style={styles.addEventButton}
                clickHandler={
                  this.props.calender ? this.addDateEvent : this.addTimeEvent
                }
              >
                {" "}
                Add Event{" "}
              </CommitButtonWithClickState>
            </>
          ) : (
            <SkeletonWrapper
              height="300"
              width={this.state.skeletonWidth}
              containerStyle={{
                width: "100%",
                height: "300px"
              }}
            >
              <rect
                x={0}
                y={0}
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
              <rect
                x={0}
                y="50"
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
              <rect
                x={0}
                y="100"
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
              <rect
                x={0}
                y="150"
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
              <rect
                x={0}
                y="200"
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
              <rect
                x={0}
                y="250"
                width={800 * this.state.skeletonWidthRatio}
                height="40"
              />
            </SkeletonWrapper>
          )}
        </div>
      )
    }
  }
)

const styles = {
  dragContainer: {
    margin: "auto",
    width: "75%",
    maxWidth: "699px"
  },
  addEventButton: {
    marginTop: "16px",
    marginBottom: "16px",
    maxWidth: "133px",
    height: "44px"
  }
}
